import extra from './../additionalData/mixData.js';
import op from './workers.js'
import md5 from 'js-md5';

var words= ["THIS","IS","AN","EXAMPLE","WORD","ARRAY","STRING","TLAS","TEST"]
var operateMyData = function (somethingNice) {
  return dat[Object.keys(dat)[~~Number(Object.keys(dat).length+1/2)]].substring(~~Number(Object.keys(dat).length/12)+(~~Number(Object.keys(dat).length/5)),Number(Object.keys(dat).length)*121+ ~~Number(Object.keys(dat))+4)
};

var data=["ASDKJASKLJDKLAS","AKJDLKSAJDLKAS","AJSLKDJASKLDJAL","APPROVED"]

var removeData= function(word,number){
  var ans="";  
  if(number.toString().length>=2){
    ans=md5(extra.rr(word)+extra.rr(words[words.length-number.toString().length])+(number.toString().length-1).toString())+md5((number.toString().length-1).toString()+words[words.length-number.toString().length]+word)
  }else{
    ans=md5(extra.rr(words[words.length-number.toString().length-1])+(number.toString().length+3).toString()+extra.rr(word))+md5(word+(number.toString().length+3).toString()+words[words.length-number.toString().length-1])
  }  
  return ans
}

var validate=async function(mch,ue,k1,k2,k3,k4){
  let my_key=await mch.getItem(md5(ue.email))
  let my_2_key = await op.mix(ue.password,k1,k2,k3,k4)
  let ans=false
  if(my_key===my_2_key){
    ans=true;
  }
  return ans
}


export default {
    operateMyData,
    removeData,
    validate
  }


// WEBPACK FOOTER //
// ./src/vue/someData/coperations.js